import { useEffect } from "react";
import { HashLoader } from "react-spinners";

const Loader = () => {
    useEffect(() => {
        // Add the Tailwind overflow-hidden class to the body when the component mounts
        document.body.classList.add('overflow-hidden');

        // Remove the Tailwind overflow-hidden class from the body when the component unmounts
        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, []); // Empty dependency array ensures this effect runs once on mount and cleanup on unmount


    return (
        <section id="newloader-main-blg">
            <div id="inner_loader_dv">
                <HashLoader color="#8231A7" />
            </div>
        </section>
    )
}
export default Loader
